/* eslint-disable */

import Paper from '@material-ui/core/Paper';
import {
  ArgumentAxis,
  BarSeries,
  Chart,
  Legend,
  ValueAxis,
  Tooltip as DxTooltip,
} from '@devexpress/dx-react-chart-material-ui';
import {
  Palette,
  Stack,
  Animation,
  EventTracker,
} from '@devexpress/dx-react-chart';
import React from 'react';
import { Tooltip } from '@material-ui/core';
import Info from '@material-ui/icons/InfoOutlined';
import { TooltipOverlay } from 'components';
import useWindowDimensions from 'hooks/useWindowDimensions';
import useStyles from './style';
import { IChartMajorStatusProps } from './types';
import config from './config';

const ChartMajorStatus = ({ data }: IChartMajorStatusProps) => {
  const classes = useStyles();
  const { width } = useWindowDimensions();

  const PointComponent = React.useCallback(
    ({ seriesIndex, index, ...props }) => {
      // seriesIndex === 1 valor da segunda pilha da coluna, as pilhas começam em 0
      const { total } = data[index];
      const instalationTotal = config.series.length - 1;
      return (
        <>
          <BarSeries.Point {...props} />
          <Chart.Label
            y={props.arg}
            // O gráfico provê uma função para retornar o ponto de X. Adicionando 8px para afasta a label da barra
            x={props.scales.valScale(total) + 8}
            className={classes.barLabel}
          >
            {seriesIndex === instalationTotal ? total : ''}
          </Chart.Label>
        </>
      );
    },
    [classes.barLabel, data],
  );

  const LabelMarker = React.useCallback(
    ({ color }) => {
      return (
        <>
          <rect
            style={{
              width: 8,
              height: 8,
              background: color,
            }}
          />
          <Legend.Marker className={classes.labelMarker} color={color} />
        </>
      );
    },
    [classes.labelMarker],
  );

  const LabelRoot = React.useCallback(
    ({ children, ...rest }) => {
      return (
        <Legend.Root {...rest} className={classes.labelContainer}>
          {children}
        </Legend.Root>
      );
    },
    [classes.labelContainer],
  );

  const TooltipContent = React.useCallback(
    ({ targetItem }) => {
      const series = data[targetItem.point];
      const serieName = targetItem.series;

      const seriesValue = data[targetItem.point][serieName];

      const { total } = series;
      const percent = (Number(seriesValue) / Number(total)) * 100;
      const textValue = `${seriesValue}; ${percent.toFixed(2)}%`;

      return <DxTooltip.Content targetItem={targetItem} text={textValue} />;
    },
    [data],
  );
  const mustAbbreviate = React.useMemo(() => {
    // largura aproximada de uma tela fullhd
    return width < 1900;
  }, [width]);

  const axiosLabelComponent = React.useCallback(
    (props: ArgumentAxis.LabelProps) => {
      let abrev = props.text;
      if (mustAbbreviate && typeof abrev === 'string' && abrev.length >= 5) {
        abrev = `${abrev.substring(0, 9)}...`;
      }
      return (
        <Tooltip title={props.text}>
          <ArgumentAxis.Label
            className={classes.labelItem}
            {...props}
            text={abrev}
          />
        </Tooltip>
      );
    },
    [classes.labelItem, mustAbbreviate],
  );

  const LabelComponent = React.useCallback(
    ({ ...props }) => {
      let abrev = props.text;
      if (mustAbbreviate && typeof abrev === 'string' && abrev.length >= 5) {
        abrev = `${abrev.substring(0, 4)}...`;
      }
      return (
        <Tooltip title={props.text}>
          <Legend.Label {...props} text={abrev} className={classes.labelText} />
        </Tooltip>
      );
    },
    [classes.labelText, mustAbbreviate],
  );

  if (!data || !data.length) {
    return (
      <div className={classes.noData}>
        <Info />
        <p>Sem dados disponíveis</p>
      </div>
    );
  }

  return (
    <Paper className={classes.statusChart}>
      <Chart rotated data={data} height={50} width={370}>
        <Palette scheme={config.palette} />
        <ArgumentAxis labelComponent={axiosLabelComponent} />
        <ValueAxis showGrid={false} showLabels={false} />

        {config.series.map((statusDescription, idx) => {
          return (
            <BarSeries
              key={idx}
              name={statusDescription.name}
              valueField={statusDescription.valueField}
              argumentField={statusDescription.argumentField}
              pointComponent={PointComponent}
            />
          );
        })}

        <Animation />
        <Stack
          stacks={[
            {
              series: config.series.map(item => item.name),
            },
          ]}
        />
        <EventTracker />
        <DxTooltip
          overlayComponent={TooltipOverlay}
          contentComponent={TooltipContent}
        />
      </Chart>
    </Paper>
  );
};

export default ChartMajorStatus;
